import { render } from "./TaskRulePopup.vue?vue&type=template&id=35daa119&scoped=true&ts=true"
import script from "./TaskRulePopup.vue?vue&type=script&lang=ts"
export * from "./TaskRulePopup.vue?vue&type=script&lang=ts"

import "./TaskRulePopup.vue?vue&type=style&index=0&id=35daa119&scoped=true&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35daa119"]])

export default __exports__